import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { IssueEntity } from './issue.entity';

@Index('issue_note_ibfk_1', ['fkIssueId'], {})
@Entity('issue_note')
export class IssueNoteEntity extends BaseEntity {
	@Column('int', { name: 'fk_issue__id', unsigned: true })
	public fkIssueId!: number;

	@Column('longtext', { name: 'note' })
	public note!: string;

	@Column('tinyint', { name: 'is_pinned', width: 1, default: 0 })
	public isPinned!: boolean;

	@ManyToOne(() => IssueEntity, (issue) => issue.issueNotes, {
		onDelete: 'CASCADE',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_issue__id', referencedColumnName: 'id' }])
	public fkIssue!: IssueEntity;
}
